/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const SIZES = {
  // NANO: 5,
  // TINY: 7,
  SMALLER: '9px',
  SMALL: '12px',
  REGULAR: '16px',
  H3: '21px',
  H2: '28px',
  H1: '37px',
  BIG: '50px',
  HUGE: '67px',
}

export const PADDING = {
  BUTTON_REGULAR: ' 0.5em 1em',
  BUTTON_SMALL: '0.2em 0.5em',
}

export const SANS_SERIF = `Roboto, 'canada-type-gibson', -apple-system, 'Helvetica Neue', Helvetica,
  'Segoe UI', Arial, sans-serif`
export const SERIF = 'Georgia, serif'
export const BASE_LINE_HEIGHT = '1.5em'
